"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSetEqual = isSetEqual;
function isSetEqual(as, bs) {
    if (as.size !== bs.size)
        return false;
    for (const a of as)
        if (!bs.has(a))
            return false;
    return true;
}
